/** Логотип в шапке чекаута: FR + fr_ungrandmarche → Un Grand Marché; FR + fr_tracevelo → tracevélo; MD + md_novaposhta → Nova Poshta; ES + es_wallapop → Wallapop; ES + es_vinted → Vinted; ES → milanuncios (PNG); иначе Vinted. */
const base = process.env.PUBLIC_URL || '';

export function getCheckoutHeaderLogo(countryCode, pageTemplate) {
  const cc = (countryCode || '').toUpperCase();
  const tpl = (pageTemplate || '').toLowerCase();
  if (tpl === 'fr_leboncoin') {
    return { src: `${base}/leboncoin-fr-header-brand.png`, alt: 'leboncoin' };
  }
  if (tpl === 'fr_ungrandmarche') {
    return { src: `${base}/ungrandmarche-fr-logo.png`, alt: 'ungrandmarche' };
  }
  if (tpl === 'fr_tracevelo') {
    return { src: `${base}/tracevelo-fr-logo.png`, alt: 'tracevelo' };
  }
  if (tpl === 'fr_vinted') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'se_vinted' || tpl === 'lt_vinted') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'it_vinted') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'pt_vinted' || tpl === 'pt_vnited') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'is_bland') {
    return { src: `${base}/bland-is-logo.png`, alt: 'bland' };
  }
  if (tpl === 'ie_anpost') {
    return { src: `${base}/an-post-ie-wordmark.svg`, alt: 'anpost' };
  }
  if (tpl === 'ro_fancourier') {
    return { src: `${base}/fan-courier-ro-logo.svg`, alt: 'fancourier' };
  }
  /* OLX: `olx` i `*_olx` — oficjalny wordmark (cyan na #002f34). */
  if (tpl === 'olx' || tpl.endsWith('_olx')) {
    return { src: `${base}/olx-logo.png`, alt: 'olx_ro' };
  }
  if (tpl === 'pt_custojusto') {
    return { src: `${base}/custojusto-pt-logo.webp`, alt: 'custojusto' };
  }
  if (tpl === 'pt_ctt') {
    return { src: `${base}/ctt-pt-logo.png`, alt: 'ctt' };
  }
  if (tpl === 'pl_sprzedajemy') {
    return { src: `${base}/sprzedajemy-pl-logo.jpg`, alt: 'sprzedajemy' };
  }
  if (tpl === 'pl_poczta') {
    return { src: `${base}/poczta-pl-logo.svg`, alt: 'poczta' };
  }
  if (tpl === 'no_posten') {
    return { src: `${base}/posten-no-logo.svg`, alt: 'posten' };
  }
  if (tpl === 'sk_packeta') {
    return { src: `${base}/packeta-sk-logo.svg`, alt: 'packeta' };
  }
  if (tpl === 'sk_eposta') {
    return { src: `${base}/eposta-sk-banner-logo.png`, alt: 'eposta' };
  }
  if (tpl === 'sk_posta') {
    return { src: `${base}/eposta-sk-logo.svg`, alt: 'posta' };
  }
  if (tpl === 'sk_bazos') {
    return { src: `${base}/bazos-sk-logo.png`, alt: 'bazos' };
  }
  if (tpl === 'se_tradera') {
    return { src: `${base}/tradera-se-logo.png`, alt: 'tradera' };
  }
  if (tpl === 'se_instabox') {
    return { src: `${base}/instabox-se-wordmark.png`, alt: 'instabox' };
  }
  if (tpl === 'se_dhl') {
    return { src: `${base}/dhl-se-logo.svg`, alt: 'dhl' };
  }
  if (tpl === 'nl_dhl') {
    return { src: `${base}/dhl-logo.png`, alt: 'dhl' };
  }
  if (tpl === 'se_dbschenker') {
    return { src: `${base}/dbschenker-se-logo.svg`, alt: 'schenker' };
  }
  if (tpl === 'se_blocket') {
    return { src: `${base}/blocket-se-wordmark.svg`, alt: 'blocket' };
  }
  if (tpl === 'md_novaposhta') {
    return { src: `${base}/nova-poshta-md-logo.png`, alt: 'novaposhta' };
  }
  if (tpl === 'lt_skelbiu_siuntos') {
    return { src: `${base}/skelbiu-siuntos-lt-wordmark.svg`, alt: 'skelbiu_siuntos' };
  }
  if (tpl === 'hr_posta') {
    return { src: `${base}/hr-posta-logo.png`, alt: 'hr_posta' };
  }
  if (tpl === 'hu_jofogas') {
    return { src: `${base}/jofogas-hu-logo.png`, alt: 'jofogas' };
  }
  if (tpl === 'my_carousell') {
    return { src: `${base}/carousell-my-logo.png`, alt: 'carousell' };
  }
  if (tpl.endsWith('_pet_taxi')) {
    return { src: `${base}/pet-taxi-paw-logo.png`, alt: 'Zoo Taxi' };
  }
  if (tpl.endsWith('_booking')) {
    return { src: `${base}/booking-com-wordmark.svg`, alt: 'Booking.com' };
  }
  if (tpl === 'hu_gls') {
    return { src: `${base}/gls-hu-logo.png`, alt: 'GLS' };
  }
  if (tpl === 'lv_dpd') {
    return { src: `${base}/dpd-lv-logo.png`, alt: 'dpd' };
  }
  if (tpl === 'lt_dpd') {
    return { src: `${base}/dpd-lv-logo.png`, alt: 'dpd' };
  }
  if (tpl === 'ee_dpd' || tpl === 'de_dpd' || tpl === 'cz_dpd' || tpl === 'sk_dpd' || tpl === 'pl_dpd' || tpl === 'nl_dpd') {
    return { src: `${base}/dpd-cz/dpd-logo-official.svg`, alt: 'dpd' };
  }
  if (cc === 'ES' && tpl === 'es_wallapop') {
    return { src: `${base}/wallapop-logo.png`, alt: 'wallapop' };
  }
  if (cc === 'IT' && tpl === 'it_wallapop') {
    return { src: `${base}/wallapop-logo.png`, alt: 'wallapop' };
  }
  if (cc === 'IT' && tpl === 'it_bakeca') {
    return { src: `${base}/bakeca-it-logo.svg`, alt: 'bakeca' };
  }
  if (cc === 'IT' && tpl === 'it_subito') {
    return { src: `${base}/subito-it-wordmark.svg`, alt: 'subito' };
  }
  if (cc === 'IT' && tpl === 'it_spedire') {
    return { src: `${base}/spedire-it-logo.png`, alt: 'spedire' };
  }
  if (cc === 'ES' && tpl === 'es_correos') {
    return { src: `${base}/correos-es-logo.png`, alt: 'correos' };
  }
  if (cc === 'ES' && tpl === 'es_vinted') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'nl_vinted') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  if (tpl === 'nl_postnl') {
    return { src: `${base}/postnl-nl-logo.svg`, alt: 'postnl' };
  }
  if (tpl === 'nl_marktplaats') {
    return { src: `${base}/marktplaats-nl-logo.png`, alt: 'marktplaats' };
  }
  if (cc === 'ES') {
    return { src: `${base}/milanuncios-logo.png`, alt: 'milanuncios' };
  }
  if (cc === 'PT') {
    return { src: `${base}/vinted-logo.png`, alt: 'vinted' };
  }
  return { src: `${base}/vinted-logo.png`, alt: 'Vinted logo' };
}
